import EventEmitter from "eventemitter3";

interface IOnmoHtmlGameCallbacks {
  pause: () => void;
  resume: () => void;
  unload: () => void;
  addListener: (type: string, listener: () => void, options?: object) => void;
  removeListener: (
    type: string,
    listener?: () => void,
    options?: object,
  ) => void;
  soundOn: () => void;
  soundOff: () => void;
  seed: () => void;
  momentData: () => void;
}
declare global {
  // eslint-disable-next-line no-var
  var onmoHtmlGame: OnmoHtmlGame | null;
  // eslint-disable-next-line no-var
  var OnmoHtmlGame: {
    EVENTS: Record<string, string>;
  };
}

export type IPostMessage = {
  response_id?: string;
  status?: number;
  message?: string;
  callback_func?: string;
};

export class OnmoHtmlGame extends EventEmitter {
  callbacks?: IOnmoHtmlGameCallbacks;
  momentDatas?: string;
  seeds?: number | object;
  isFullGameMode?: boolean;
  listMomentData?: string;
  postMessageToFrame?: (message: IPostMessage) => void;
  static EVENTS = {
    DATA: "DATA",
    LOADING: "LOADING",
    LOADED: "LOADED",
    UNLOADED: "UNLOADED",
    END_GAME: "END_GAME",
    DOM: "DOM",
  };

  sendEvent(name: string, data = {}) {
    this.emit(name, [data]);
  }

  init(callbacks: IOnmoHtmlGameCallbacks) {
    this.callbacks = callbacks;
  }

  soundOn() {
    this.callbacks?.soundOn && this.callbacks.soundOn();
  }

  soundOff() {
    this.callbacks?.soundOff && this.callbacks.soundOff();
  }

  unload() {
    this.callbacks?.unload && this.callbacks.unload();
  }

  seed() {
    this.callbacks?.seed && this.callbacks.seed();
  }

  pause() {
    this.callbacks?.pause && this.callbacks.pause();
  }

  resume() {
    this.callbacks?.resume && this.callbacks.resume();
  }

  momentData() {
    this.callbacks?.momentData && this.callbacks.momentData();
  }

  hideCanvas(disableRetry = false) {
    let nbRetry = 0;
    const findAndhideCanvas = () => {
      if (nbRetry > 10) return;
      const canvas =
        document.getElementById("UT_CANVAS") ||
        document.getElementById("game-phaser") ||
        document.getElementById("phaser-game");
      nbRetry++;
      if (!canvas && !disableRetry) {
        setTimeout(() => {
          findAndhideCanvas();
          return;
        }, 200);
      }
      canvas?.style.setProperty("display", "none");
    };
    findAndhideCanvas();
  }

  showCanvas() {
    const canvas =
      document.getElementById("UT_CANVAS") ||
      document.getElementById("game-phaser") ||
      document.getElementById("phaser-game");
    canvas?.style.setProperty("maxWidth", "100vw");
    canvas?.style.setProperty("maxHeight", "100vh");
    canvas?.style.setProperty("width", "100%");
    canvas?.style.setProperty("height", "100%");
    canvas?.style.setProperty("display", "block");
    canvas?.style.setProperty("background", "#222323");
    canvas?.style.setProperty("position", "absolute");
    canvas?.style.setProperty("z-index", "1");
    document.body.style.backgroundColor = "#222323";
  }
}

globalThis.onmoHtmlGame = new OnmoHtmlGame();
globalThis.OnmoHtmlGame = OnmoHtmlGame;
